export function capitalizedName(record: { name: string }) {
  return (
    record?.name.charAt(0).toUpperCase() + record?.name.slice(1).toLowerCase()
  );
}

// Utility function to convert string date values to Date objects for DatePicker
export const getDateValue = (value: string | null): Date | null => {
  if (!value) return null;

  // If value is in YYYY-MM-DD format, parse it properly to avoid timezone issues
  if (value.includes("-")) {
    const [year, month, day] = value.split("-");
    // Use local date constructor to avoid timezone issues
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    return isNaN(date.getTime()) ? null : date;
  }

  // Try to parse other formats
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
};

const pad2 = (value: number) => String(value).padStart(2, "0");

/**
 * Normalizes a form date value to the `YYYY-MM-DD` a native date input wants.
 * Inverse of `getDateValue`: react-admin's DateInput stores a `Date` built from
 * local parts, so the calendar day is read back from local parts too (using
 * `toISOString` here would shift the day in positive-offset zones).
 */
export const toDateInputValue = (value: unknown): string | null => {
  if (value instanceof Date) {
    if (isNaN(value.getTime())) return null;
    return `${value.getFullYear()}-${pad2(value.getMonth() + 1)}-${pad2(
      value.getDate()
    )}`;
  }
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    return value.slice(0, 10);
  }
  return null;
};
